// Supabase client configuration and TypeScript types
const { createClient } = require('@supabase/supabase-js')

const supabaseUrl = 'https://snxduqpunoobmbgvsjsm.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNueGR1cXB1bm9vYm1iZ3ZzanNtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU1NTM3NzYsImV4cCI6MjA3MTEyOTc3Nn0.zgi2AiA7oHjCAQao7ptLBInhVYJvoDGGH6Y3GFb6gCc'

const supabase = createClient(supabaseUrl, supabaseAnonKey)

// TypeScript-like JSDoc type definitions for better IDE support

/**
 * @typedef {Object} MattressLayer
 * @property {string} id
 * @property {string} name
 * @property {string} slug
 * @property {string} [description]
 * @property {string} [image_url]
 * @property {string} [icon]
 * @property {number[]} available_heights
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} LayerPrice
 * @property {string} id
 * @property {string} layer_id
 * @property {string} size
 * @property {number} price
 * @property {string} created_at
 */

/**
 * @typedef {Object} Cover
 * @property {string} id
 * @property {string} name
 * @property {string} [slug]
 * @property {string} [description]
 * @property {number} price
 * @property {string} [image_url]
 * @property {string} [icon]
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} Order
 * @property {string} id
 * @property {string} order_number
 * @property {string} customer_name
 * @property {string} customer_email
 * @property {string} [customer_phone]
 * @property {'pickup'|'courier'} delivery_method
 * @property {'card'|'cash'|'bank'} payment_method
 * @property {Object} [delivery_address]
 * @property {string} [delivery_address.address]
 * @property {string} [delivery_address.city]
 * @property {string} [delivery_address.postalCode]
 * @property {string} [delivery_address.deliveryNotes]
 * @property {'pending'|'confirmed'|'production'|'ready'|'shipped'|'delivered'|'cancelled'} status
 * @property {number} total_amount
 * @property {string} created_at
 * @property {string} updated_at
 */

/**
 * @typedef {Object} OrderItem
 * @property {string} id
 * @property {string} order_id
 * @property {string} product_name
 * @property {number} quantity
 * @property {number} unit_price
 * @property {number} total_price
 * @property {Object} configuration
 * @property {string} configuration.cover
 * @property {string} configuration.size
 * @property {string} configuration.height
 * @property {string} [configuration.layer1]
 * @property {string} [configuration.layer2]
 * @property {string} [configuration.layer3]
 * @property {string} created_at
 */

/**
 * Frontend-compatible layer format (matches existing JSON structure)
 * @typedef {Object} FrontendLayer
 * @property {string} id
 * @property {string} name
 * @property {string} slug
 * @property {string} [description]
 * @property {string} [icon]
 * @property {number[]} availableHeights
 * @property {Object.<string, number>} prices - Size to price mapping
 * @property {number} price - Base price for compatibility
 */

/**
 * Frontend-compatible cover format
 * @typedef {Object} FrontendCover
 * @property {string} id
 * @property {string} name
 * @property {string} [slug]
 * @property {number} price
 * @property {string} [icon]
 */

/**
 * Configuration format compatible with existing frontend
 * @typedef {Object} FrontendConfig
 * @property {FrontendLayer[]} mattressLayers
 * @property {FrontendCover[]} covers
 */

module.exports = { supabase };